/* eslint-disable no-unused-vars */
import axios from "utils/httpClient";
import React, { useState, useEffect } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
// import CardAvatar from "components/Card/CardAvatar.js";
import CardBody from "components/Card/CardBody.js";
import { CardFooter } from "reactstrap";
import Table from "components/Table/TableAccess";
import Pagination from "react-responsive-pagination";
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css"
import TSSelect from "components/Forms/TSSelect";
// import avatar from "assets/img/faces/marc.jpg";
import {
  Label,
  FormGroup
} from "reactstrap";

var nowYear = new Date().getFullYear() + 543;

const optionMonth = [
  { value: 0, label: "ไม่ระบุ" },
  { value: 1, label: "มกราคม" },
  { value: 2, label: "กุมภาพันธ์" },
  { value: 3, label: "มีนาคม" },
  { value: 4, label: "เมษายน" },
  { value: 5, label: "พฤษภาคม" },
  { value: 6, label: "มิถุนายน" },
  { value: 7, label: "กรกฎาคม" },
  { value: 8, label: "สิงหาคม" },
  { value: 9, label: "กันยายน" },
  { value: 10, label: "ตุลาคม" },
  { value: 11, label: "พฤศจิกายน" },
  { value: 12, label: "ธันวาคม" },
  { value: 13, label: "ตุลาคม " + (nowYear - 1) + " - มีนาคม "+ nowYear},
  { value: 13, label: "เมษายน " + (nowYear) + " - กันยายน "+ nowYear}
];


const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    // fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontFamily: '"Sarabun", sans-serif',
    marginBottom: "3px",
    textDecoration: "none"
  }
};

const primaryColor = "#af2cc5";

const useStyles = makeStyles(styles);

const ReportAccess = (props) => {

  const paraMonth = (props.match.params.month !== undefined && props.match.params.month !== '') ? props.match.params.month : 0;

  const [optionsYear, setOptionsYear] = useState([]);
  const [tableHead, setTableHead] = useState([]);
  const [pageSize] = useState(30);
  const [data, setData] = useState([]);
  const windowWidth = useWindowWidth();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [dateFocus, setDateFocus] = useState(false);
  var moment = require('moment');
  require('moment/locale/th');
  const [StartDatetime, setStartDatetime] = useState('');
  const [EndDatetime, setEndDatetime] = useState('');
  const [holidays, setHolidays] = useState([]);
  const [modalHoliday, setModalHoliday] = useState(false);
  const [holidayText, setHolidayText] = useState('');
  const [month, setMonth] = useState("");

  useEffect(() => {}, [currentPage])

  function useWindowWidth() {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth - 400);

    useEffect(() => {
      const resizeHandler = () => {
        setWindowWidth(window.innerWidth - 400);
      };

      window.addEventListener("resize", resizeHandler);
      return () => {
        window.removeEventListener("resize", resizeHandler);
      };
    }, []);
    return windowWidth;
  }

  useEffect(() => {
        // tableHead.push("ชื่อ", "เวลา");
        // แก้ไข: ใช้ setTableHead แทน .push และไม่ต้องใส่ dependency array
        setTableHead(["ชื่อ", "เวลา"]);
        const now = new Date();
        setStartDatetime(now.toLocaleDateString("fr-CA"));
  }, []);

  useEffect(() => {
    if(StartDatetime !== ''){
    axios(
      "/api/dc/checkin/" + StartDatetime + "/" + paraMonth  +
        "/pagination?PageNumber=" +
        currentPage +
        "&PageSize=" +
        pageSize
    )
      .then(response => response.data)
      .then(
        result => {
          var tableList = [];
          if (result.data.length > 0) {
            result.data.forEach(e => {
              tableList.push([e.staffName, e.checkinDatetime]);
            });
          }

          setData(tableList);
          var total = result.total / pageSize;
          if (!Number.isInteger(total)) {
            setTotalPages((total | 0) + 1);
          } else if (total === 0) {
            setTotalPages(1);
          } else {
            setTotalPages(total);
          }
        },
        error => {
          console.log(error);
        }
      );
      }
  }, [currentPage, StartDatetime, pageSize, paraMonth]); // เพิ่ม pageSize และ paraMonth
  //}, [currentPage, StartDatetime]);

  function isDateValid(e, selectedDate) {
    var holiday = holidays.find(h => moment(h.holidayDate).format("YYYYMMDD") === moment(e).format("YYYYMMDD"))
    //return current.day() !== 0 && current.day() !== 6;
    if (holiday != null)
      return false
    else
      return (e.day() !== 0 && e.day() !== 6 && e > (new Date()).setDate((new Date().getDate() - 1)))
  }

  const handleStartDate = (date) => {
    setStartDatetime(date);
  }
  
  const handleHoliday = (txt) => {
    setHolidayText(txt);
    setModalHoliday(true);
  }

  function renderDay(props, currentDate, selectedDate) {
    var holiday = holidays.find(h => moment(h.holidayDate).format("YYYYMMDD") === moment(currentDate).format("YYYYMMDD"))
    var hdt = (holiday != null) ? holiday.name : '';

  if ((props.className.indexOf('rdtDisabled') >= 0) && (currentDate.day() !== 0 && currentDate.day() !== 6 && currentDate > (new Date()).setDate((new Date().getDate() - 1)))) {
    props.className += ' text-danger';
    return <td >
    <button
      onClick={e => handleHoliday(hdt)}
      class="btn btn-danger btn-icon btn-round" style={{ background: 'red' }}
    >
    <span className="text-white" style={{ textDecoration: 'Line-Through' }}>{currentDate.date()}</span>
      </button>
    </td>; 
    }
    else {
        return <td {...props}>{currentDate.date()}</td>;
    }
  }


  const classes = useStyles();
  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="info">
                {parseInt(paraMonth) === 0 && (<div><h4 className={classes.cardTitleWhite}>รายชื่อผู้เข้าออกห้อง Datacenter</h4> 
                <p className={classes.cardCategoryWhite}> กรุณาเลือกวันที่ </p></div>)}  
                {parseInt(paraMonth) !== 0 && (<div><h4 className={classes.cardTitleWhite}>รายงานประจำเดือน</h4> </div>)}  
            </CardHeader>
            <CardBody> 
              <GridContainer>
              {parseInt(paraMonth) === 0 && (<GridItem xs={12} sm={6} md={6}>
                  <Label>วันที่เข้าห้อง Datacenter</Label>
                    <FormGroup
                      style={{ padding: '0 0px', marginBottom: '10px' }}
                      className={"input-lg" + (dateFocus ? " input-group-focus" : "")}
                    >
                    <i className="far fa-calendar-check fa-2x" style={{
                      position: 'absolute', left: '30px', zIndex: 1,}}>
                    </i>
                    <Datetime
                        value={moment(StartDatetime).isValid() ? moment(StartDatetime) : null}
                        renderYear={function (props, year, selectedDate) { return <td {...props}>{year + 543}</td>; }}
                        //isValidDate={isDateValid}
                        renderDay={renderDay}
                        //onBeforeNavigate={(a, b, c) => handleNavigate(a, b, c)}
                        //onNavigateForward={(dayAmt, unit) => handleCurrentDate(dayAmt, unit)}
                        //onNavigateBack={(dayAmt, unit) => handleCurrentDate((-1 * dayAmt), unit)}
                        inputProps={{
                          name: "วันที่เข้าห้อง Datacenter", placeholder: "วันที่เข้าห้อง Datacenter", readOnly: 'readonly', 
                            style: { fontSize: '1.2em', borderRadius: 0, paddingLeft: '50px', cursor: 'pointer', 
                                      background: '#ffffff', color: '#000000'}
                        }}
                        closeOnSelect={true}
                        closeOnTab={true}
                        dateFormat="D MMMM BBBB" timeFormat={false}
                        //dateFormat="D MMMM BBBB" timeFormat="เวลา HH:mm น."
                        //timeFormat={false}
                        onFocus={() => setDateFocus(true)}
                        onBlur={() => setDateFocus(false)}
                        onChange={e => handleStartDate(e.format('YYYY-MM-DD'))}                                             
                    />      
                  </FormGroup>
                </GridItem> )}
                {parseInt(paraMonth) === 0 && (<GridItem xs={12} sm={6} md={6}>

                </GridItem>)}
                {/* {paraMonth != 0 && (<GridItem xs={12} sm={12} md={6}>
                  <div style={{ padding: '0 0px', marginBottom: '10px' }}> 
                  <TSSelect
                    options={optionMonth}
                    zIndex={998}
                    onChange={e => setMonth(e)}
                    default={optionMonth[0]}
                  />
                   </div>
                </GridItem>)} */}
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
           <CardHeader color="info">
              {parseInt(paraMonth) === 0 && (<h4 className={classes.cardTitleWhite}>รายชื่อผู้เข้าออกห้อง Datacenter </h4>)}
              {parseInt(paraMonth) !== 0 && (<h4 className={classes.cardTitleWhite}>รายชื่อผู้เข้าออกห้อง Datacenter ประจำเดือน {optionMonth[paraMonth] ? optionMonth[paraMonth].label : ''}</h4>)}
              <p className={classes.cardCategoryWhite}>
              </p>
            </CardHeader>
            <CardBody>
              <Table
                tableHeaderColor="info"
                tableHead={tableHead}
                tableData={data}
              />
            </CardBody>
            <CardFooter>
              <Pagination
                current={currentPage}
                total={totalPages}
                onPageChange={setCurrentPage}
                maxWidth={windowWidth}
              />
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}

export default ReportAccess;